import { render, staticRenderFns } from "./ProductInfoVideo.vue?vue&type=template&id=598e94b0&"
import script from "./ProductInfoVideo.vue?vue&type=script&lang=js&"
export * from "./ProductInfoVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports